import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []); // This ensures scrolling to the top even on refresh

  useEffect(() => {
    // Scroll to the top on route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
